module.exports = __webpack_public_path__ + "img/model-back.d4a44e77.svg";